// Utilitários compartilhados pelo Pipeline Comercial: formatação de valor,
// cálculo de dias decorridos, mapas de status/cores.
// Extraído de ComercialPipeline.tsx em 2026-05-23 (frontend wave 3B).

export const fmt = (v: number | string | null | undefined, casasDecimais = 0) => {
  const n = typeof v === 'number' ? v : parseFloat(v as any);
  return 'R$ ' + Math.abs(Number.isFinite(n) ? n : 0).toLocaleString('pt-BR', {
    minimumFractionDigits: casasDecimais,
    maximumFractionDigits: casasDecimais,
  });
};

// Dias decorridos desde uma data ISO. Negociais antigos ficam destacados.
export const diasDesde = (iso: string): number => {
  if (!iso) return 0;
  const d = new Date(iso.split('T')[0] + 'T12:00:00');
  const hoje = new Date();
  hoje.setHours(12, 0, 0, 0);
  return Math.max(0, Math.floor((hoje.getTime() - d.getTime()) / 86400000));
};

// L16 (2026-06-03) — dias até uma data ISO (positivo = futuro, negativo = passado).
// Para licitações, onde data_abertura é futura: usar pra mostrar urgência.
export const diasAte = (iso: string): number => {
  if (!iso) return 0;
  const d = new Date(iso);
  const ms = d.getTime() - Date.now();
  return Math.ceil(ms / 86400000);
};

// Cor + label + bold do contador de dias pra abertura de licitação.
// Usado no card Kanban e em qualquer outro lugar que mostre prazo.
export function urgenciaAbertura(dias: number) {
  if (dias < 0)    return { cor: '#B91626', label: `vencida há ${Math.abs(dias)}d`, bold: true, icone: '⚠' };
  if (dias === 0)  return { cor: '#B91626', label: 'HOJE',                          bold: true, icone: '🔥' };
  if (dias === 1)  return { cor: '#B91626', label: 'amanhã',                         bold: true, icone: '🕐' };
  if (dias <= 3)   return { cor: '#B91626', label: `em ${dias} dias`,               bold: true, icone: '🕐' };
  if (dias <= 7)   return { cor: '#B07500', label: `em ${dias} dias`,               bold: false, icone: '🕐' };
  if (dias <= 30)  return { cor: '#0a7f4a', label: `em ${dias} dias`,               bold: false, icone: '🕐' };
  return            { cor: '#444',    label: `em ${dias} dias`,               bold: false, icone: '🕐' };
}

export const STATUS_LABELS: Record<string, string> = {
  prospeccao: 'Aguardando 1º Contato',
  qualificacao: 'Identificação de Necessidades',
  proposta: 'Proposta',
  follow_up: 'Follow-up',
  negociacao: 'Negociação',
  ganho: 'Fechamento',
  perdido: 'Perdido',
  cancelado: 'Cancelado',
};

export const STATUS_COLORS: Record<string, { bg: string; color: string; tagColor: string }> = {
  prospeccao:   { bg: '#F4F5F8', color: '#5A6378', tagColor: 'default' },
  qualificacao: { bg: '#EEF1F6', color: '#4A6285', tagColor: 'blue' },
  proposta:     { bg: '#F4EFE8', color: '#7A6440', tagColor: 'gold' },
  follow_up:    { bg: '#E8EBF4', color: '#3B5485', tagColor: 'geekblue' },
  negociacao:   { bg: '#F0EAD9', color: '#6B5320', tagColor: 'orange' },
  ganho:        { bg: '#E6F0EA', color: '#2C5C42', tagColor: 'green' },
  perdido:      { bg: '#F1E5E5', color: '#8B3A3A', tagColor: 'red' },
  cancelado:    { bg: '#F2F3F5', color: '#7A7F8C', tagColor: 'default' },
};

// Cor da borda lateral do card de negócio — baseada na idade (dias desde abertura).
// Verde recente, amarelo médio, vermelho velho. Mesma lógica de prioridade do kanban
// de Atividades — sinaliza visualmente o que precisa de atenção sem ocupar texto.
export const corPorIdade = (dias: number) => dias > 60 ? '#B91626' : dias > 30 ? '#B07500' : '#0a7f4a';

// Lista canonical de colunas do funil de propostas (ordem usada no Kanban).
export const COLUNAS_KANBAN = ['prospeccao', 'qualificacao', 'proposta', 'follow_up', 'negociacao', 'ganho', 'perdido'];
